import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControlLabel, Checkbox, CircularProgress, Alert } from '@metarouter-private/mr-mui';
import { useQueryWebhookEventTypes } from '@ion/api';

export default function EventTypeCheckboxes({ selectedTypes, onChange }) {
  const { eventTypes, loading, error } = useQueryWebhookEventTypes();

  if (loading) return <CircularProgress size={24} />;
  if (error) return <Alert severity="error">Failed to load event types.</Alert>;

  const handleToggle = eventType => {
    const next = selectedTypes.includes(eventType)
      ? selectedTypes.filter(type => type !== eventType)
      : [...selectedTypes, eventType];
    onChange(next);
  };

  return (
    <FormGroup>
      {eventTypes.map(({ value, comment }) => (
        <FormControlLabel
          key={value}
          label={comment ?? value}
          control={<Checkbox checked={selectedTypes.includes(value)} onChange={() => handleToggle(value)} />}
        />
      ))}
    </FormGroup>
  );
}

EventTypeCheckboxes.propTypes = {
  selectedTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
